module.exports = __webpack_public_path__ + "static/media/27-iveco.77604cbc.jpg";